<template>
    <div>
        <div class="d-flex justify-content-center">
            <img src="@/assets/rewards-image-dark-m.jpg" class="background-img d-block d-sm-block d-md-block d-lg-none d-xl-none">
            <img src="@/assets/rewards-image-dark.jpg" class="background-img d-none d-sm-none d-md-none d-lg-block d-xl-block">
        </div>
        <div class="background">
            <div class="container">
                <h1 class="title mb-3">Email Sent</h1>
                <p class="text pb-3 mb-3">
                    We have sent an email to <span class="email-font-weight">{{ email }}</span>. Please check your inbox and open the email to retrieve your Rewards card number.
                </p>
                <h1 class="title mb-3">Haven’t received the email?</h1>
                <p class="text mb-3">
                    If your email address is linked to a Rewards card account, the email should arrive in a few moments. If you can't see it, please check your bulk or junk folders. If you do not receive the email, please contact Customer Service team on:
                </p>
                <p class="hyperlink">+44 (0)20 7730 1234</p>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { useRouter } from 'vue-router'

    const props = defineProps({
        email: {
            type: String,
            required: true
        }
    })

    const router = useRouter()

    if (!props.email) {
        router.push({ path: '/en-gb' })
    }
</script>

<style lang="scss" scoped>
    @import '@/scss/_retrieve-rewards-card.scss';
</style>
